import { render, staticRenderFns } from "./explainer-customer-response.vue?vue&type=template&id=ee63584c&scoped=true&"
import script from "./explainer-customer-response.vue?vue&type=script&lang=js&"
export * from "./explainer-customer-response.vue?vue&type=script&lang=js&"
import style0 from "./explainer-customer-response.vue?vue&type=style&index=0&id=ee63584c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee63584c",
  null
  
)

export default component.exports